import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import FCLink from '../fc_link/fc_link';
import franchises from './franchise_data';

export default class FranchiseRow extends Component {
  renderFranchies() {
    const { config } = this.props;

    return franchises.map((franchise, index) => (
      <div className="franchise" key={`franchise-${index}`}>
        <FCLink title={franchise.title} to={franchise.link} config={config}>
          <figure className="franchise__photo">
            <img
              src={franchise.image
                .replace('.png', '.webp')
                .replace('.jpg', '.webp')}
              alt={franchise.title}
            />
          </figure>
          <div className="franchise__head">
            <h2 className="franchise__head--title">{franchise.title}</h2>
            <div className="franchise__head--logo">
              <img src={franchise.logo} alt={franchise.title} />
            </div>
          </div>
          <p className="franchise__description">{franchise.description}</p>
        </FCLink>
      </div>
    ));
  }

  render() {
    if (!this.props) {
      return null;
    }
    const { config } = this.props;
    const { initialPageLoad } = config;

    const settings = {
      arrows: false,
      infinite: true,
      className: 'row franchise-showcase',
      slidesToScroll: 1,
      slide: '.franchise',
      dots: true,
      dotsClass: 'franchise-pagination',
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 1024
        },
        {
          breakpoint: 100000,
          settings: 'unslick'
        }
      ]
    };

    if (initialPageLoad) {
      return (
        <div className="row franchise-showcase">{this.renderFranchies()}</div>
      );
    }

    return (
      <Slider {...settings} key="franchise-showcase">
        {this.renderFranchies()}
      </Slider>
    );
  }
}

FranchiseRow.propTypes = {
  config: PropTypes.shape({}).isRequired
};
